exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn.btn-icon[data-v-01bcfb02]{height:1.8rem;width:1.8rem}.btn [class*=\" fa-\"][data-v-01bcfb02]{font-size:.8rem}.border-dashed[data-v-01bcfb02]{border:1px dashed;height:140px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-01bcfb02","scoped":true,"sourceMap":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/BeerClaim/AddBeerClaimItem.vue
// module id = 872
// module chunks = 0